import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { ChartData, ChartOptions, ChartType } from 'chart.js';
import { Chart } from 'chart.js/auto';
import { BaseChartDirective } from 'ng2-charts';
import { RekbotsService } from '../services/rekbots.service';
import { Rekbot } from '../models/rekbot.model';
import { Router, RouterLink } from '@angular/router';
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from '@angular/material/paginator';
import { CommonModule } from '@angular/common';
import { RekbotLogItem } from '../models/rekbotLogItem.model';
import { catchError, finalize, forkJoin, from, interval, mergeMap, of, Subject, switchMap, takeUntil, toArray } from 'rxjs';
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatTabGroup, MatTab } from "@angular/material/tabs";
import { RekbotNote } from '../rekbots/rekbot-layout/rekbot-layout-models/rekbot-note.model';
import { MatIcon } from '@angular/material/icon';
import { User } from '../models/user.model';
import { AuthService } from '../services/auth.service';
import { RekbotNotesService } from '../services/rekbots-notes.service';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { ModalConfirmDeleteNoteComponent } from './modal-confirm-delete-note/modal-confirm-delete-note.component';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-dashboard',
  imports: [
    MatCardModule,
    CommonModule,
    BaseChartDirective,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinner,
    RouterLink,
    MatTabGroup,
    MatTab,
    MatIcon,
    MatButtonModule,
    MatTooltip,
],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent implements OnInit, OnDestroy {

  constructor(
    private rekbotsService: RekbotsService,
    private router: Router,
    private authService: AuthService,
    private rekbotNotesService: RekbotNotesService,
    private dialog: MatDialog,
  ) { 
  }

  user: User = this.authService.getUser()!;
  rekbots: Rekbot[] = [];
  // rekbotsErrorLog:{rekbot:Rekbot, rekbot_log: RekbotLogItem }[] = [];
  rekbotsError: Rekbot[] = [];
  rekbotsInfo: Rekbot[] = [];
  rekbotsStatusData: { ok: number, info: number, error: number, offline: number } = { ok: 0, info: 0, error: 0, offline: 0 };
  isLoading:boolean = true;
  notesDeleteRequest: RekbotNote[] = [];

  private destroy$ = new Subject<void>()


  ngOnInit(): void {
    this.rekbotsStatusData = { ok: 0, info: 0, error: 0, offline: 0 };
    forkJoin({
      rekbots: this.rekbotsService.fetchRekbots(),
      notes: this.rekbotNotesService.fetchRequestDeleteNote()
    }).subscribe({
      next:({ rekbots, notes }) => {
        console.log("notatki", notes);
        console.log("rekbots", rekbots);
        
        this.rekbots = rekbots.filter((rek:Rekbot) => rek.production_status === 2)
        this.countRekbotsStatus();
        this.notesDeleteRequest = notes.requests;
        this.isLoading = false;
      },
        error: error => {
          console.error("fetch data error", error)
      }}
    );
    
    // this.fetchRekbotsInterval();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  fetchRekbots(): void {
    this.rekbotsStatusData = { ok: 0, info: 0, error: 0, offline: 0 };
    this.rekbotsService.fetchRekbots()
      .subscribe({
        next: (response: any) => {
          console.log("fetchRekbots response", response);

          this.rekbots = response.filter((rek:Rekbot) => rek.production_status === 2)
          this.countRekbotsStatus();
          this.isLoading = false;
        },
        error: error => {
          console.log("fetchrekbots error", error)
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
        }
      });
  }

  fetchNotesDeleteRequest() {
    this.rekbotNotesService.fetchRequestDeleteNote()
      .subscribe({
        next: (response: any) => {
          this.notesDeleteRequest = response;
        },
        error: error => {
          console.error("fetchNotesDeleteRequest error", error);
        }
      });
  }

  fetchRekbotsInterval(): void {
    // this.rekbotsStatusData = { ok: 0, error: 0, offline: 0 };
    interval(60000)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => console.log("Zakończony Interval"))
      )
      .subscribe({
        next: () => {
          console.log('Wywołanie fetch z interval');
          this.fetchRekbots();
      }});
  }

  onOpenRekbot(id:number) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/rekbot/'+id])
    );

    window.open('/#' + url, '_blank');
  }

  countRekbotsStatus() {
    // this.rekbotsErrorLog = [];

    this.rekbotsStatusData.ok = this.rekbots.filter(rek => rek.status_new === 10).length;
    this.rekbotsInfo = this.rekbots
    .filter(rek => rek.status_new === 2)
    .map(rek => ({
      ...rek,
      namedStatus: rek.log_last_entry!
      .map(e => e.message_type?.name || e.message)
      .join(', ')
    }));
    this.rekbotsInfo
    // rekbot.log_last_entry?.map(e => e.message_type?.name || e.message).join(', ') 
    // console.log("Rekboty w info: ", this.rekbotsInfo[0].log_last_entry![0].message_type!.name);
    
    this.rekbotsStatusData.info = this.rekbotsInfo.length;
    this.rekbotsError = this.rekbots
    .filter(rek => rek.status_new === 1)
    .map(rek => ({
      ...rek,
      namedStatus: rek.log_last_entry!
      .map(e => e.message_type?.name || e.message)
      .join(', ')
    }));;
    // console.log("Rekboty w error: ", this.rekbotsError[0].log_last_entry![0].message_type!.name);
    this.rekbotsStatusData.error = this.rekbotsError.length;
    this.rekbotsStatusData.offline = this.rekbots.filter(rek => rek.status_new === 0).length;
    
    this.chartData = {
      labels: [
        'Ok',
        'Error',
        'Offline'
      ],
      datasets: [{
        label: 'Rekbots',
        data: [this.rekbotsStatusData.ok, this.rekbotsStatusData.info, this.rekbotsStatusData.error, this.rekbotsStatusData.offline],
        backgroundColor: [
          'rgba(99, 255, 133, 1)',
          'rgb(18, 144, 167)',
          'rgb(255, 99, 132)',
          'rgb(255, 205, 86)'
        ],
        hoverOffset: 4,
        borderWidth: 0,
      }]
    }
  }

  public chartOptions: ChartOptions = {
    // responsive: true,
    layout: {
      padding:5,
    },
    plugins: {
      legend: {
        display: false,
      }
    }

  }

  public chartData: ChartData = {
    labels: [
      'Ok',
      'Error',
      'Offline'
    ],
    datasets: [{
      label: 'Rekbots',
      data: [0, 0, 0],
      backgroundColor: [
        'rgba(99, 255, 133, 1)',
        'rgb(255, 99, 132)',
        'rgb(255, 205, 86)'
      ],
      hoverOffset: 4,
      borderWidth: 0,
    }]
  }
  
  onConfirmDeleteNote(note: RekbotNote) {
    console.log("delete Note", note);
    this.dialog.open(ModalConfirmDeleteNoteComponent, {
      width: '400px',
      data: {
        note: note,
        rekbotSerial: this.getRekbotSerial(note.rekbot_id)
      }
    }).afterClosed().subscribe(result => {
      if(result === "success") {
        this.fetchNotesDeleteRequest();
      }
    });
  }

  cancelDeleteRequest(note: RekbotNote) {
    if(confirm("Czy na pewno chcesz anulować prosbę?")) {
      this.rekbotNotesService.cancelRequestDeleteNote(note.rekbot_id, note)
        .subscribe({
          next: () => {
            console.log("Anulowano prośbę usunięcia notatki", note.id);
            this.fetchNotesDeleteRequest();
          },
          error: err => {
            console.error("Błąd podczas anulowania prośby usunięcia notatki", err);
          }
        });
    }
    
  }

  getRekbotSerial(rekbotId: number): string {
    const rekbot = this.rekbots.find(r => r.id === rekbotId);
    return rekbot ? rekbot.serial_no : 'nieznany numer seryjny';
  }
}
